module.exports = __webpack_public_path__ + "img/zhuozi_school_name.3de39eb5.png";